<template>
  <div>
    <div class="lighten-5">
      <router-view></router-view>
    </div>
    <v-container>
      <v-list two-line subheader>
        <v-list-item
          v-for="example in examples"
          :key="example.content"
          :to="{ name: 'StudyListDetail', params: { id: example.id } }"
          link
        >
          <v-list-item-content>
            <v-list-item-title v-text="example.content"></v-list-item-title>
            <v-list-item-subtitle
              v-text="example.description"
            ></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-menu bottom left transition="slide-y-transition">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop.prevent>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="deleteConfirmation(example.id)">
                  <v-list-item-action>
                    <v-icon>mdi-delete</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
        </v-list-item>

        <v-list-item :key="'__newitem__'" link @click="newItem">
          <v-list-item-avatar>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Add a new example</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
    <v-dialog v-model="showAddExampleDialog" max-width="800px">
      <AddExample
        studyList="editStudyList"
        v-bind:onFinish="closeAddItemDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import store from "@/store";
import AddExample from "@/components/AddExample.vue";

export default {
  name: "Item",
  props: {
    id: {
      required: true
    }
  },
  data: () => ({
    showAddExampleDialog: false
  }),

  beforeRouteEnter(to, _, next) {
    Promise.all([
      store.dispatch("fetchItem", to.params.id)
      // store.dispatch('fetchItems', to.params.id)
    ]).then(() => {
      next();
    });
  },

  computed: mapGetters(["item", "examples"]),

  methods: {
    ...mapActions(["deleteExample"]),

    newItem() {
      this.showAddExampleDialog = true;
    },
    closeAddItemDialog() {
      this.showAddExampleDialog = false;
    },
    deleteConfirmation(id) {
      if (confirm("Delete this example?")) {
        this.deleteExample({
          itemId: this.item.id,
          exampleId: id
        });
      }
    }
  },

  components: {
    AddExample
  }
};
</script>
